import store from "@/store";

/**
 * 在当前门户页弹出登录层（不跳转路由）
 * @param {string} [redirect] 登录成功后跳转路径
 */
export function openPortalLogin(redirect) {
  store.commit("OPEN_PORTAL_LOGIN", redirect || "");
}

/** 关闭门户登录弹层 */
export function closePortalLogin() {
  store.commit("CLOSE_PORTAL_LOGIN");
}
